import axios from "axios";

export { createPriceQuote, getSellerPriceQuotes, updatePriceQuoteBasketExpiry };

function createPriceQuote(basketId, expirationTimeInMinutes, buyerAccountId, isContract) {
  const payload = {
    priceQuoteExpiryMins: expirationTimeInMinutes,
    basketId,
    buyerAccountId,
    isContract,
  };
  return axios.post("/api/createPriceQuote", payload);
}

async function getSellerPriceQuotes(dto) {
  const { data } = await axios.get("/api/getSellerPriceQuotes", { params: dto });
  return { priceQuotes: data.priceQuotes, metadata: data.metadata };
}

async function updatePriceQuoteBasketExpiry(priceQuoteId) {
  const payload = {
    priceQuoteId,
  };
  const response = await axios.put("/api/updatePriceQuoteBasketExpiry", payload);
  return response.data.updatedBasketExpiry;
}
